export const state = {
  ordemServico: {
    id: "",
    subotal: "0,00",
    desconto: "0,00",
    acrescimo: '0,00',
    total: "0,00",
    status: "EM ABERTO",
    cliente_id: "",
    tecnico_id: "",
    telefone: "",
    celular_1: "",
    whatsapp: "",
    cep: "",
    logradouro: "",
    bairro: "",
    estado: "",
    cidade: "",
    numero: "",
    data_inicio: "",
    data_fim: "",
  },
  ordensServicos: [],
  modalCadastroOrdemServico: false,
  modalExcluirOrdemServico: false,
  modalHistoricoStatusOS: false,
  modalPagamentoOrdemServico: false,
  statusOrdemServico: ["", "EM ABERTO", "EM ANDAMENTO", "CONCLUÍDO", "CANCELADO"],
};

export default {};
